import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_BusTrackerMap } from "../shared/data.service";
import { GeoFenceAlertToggleRequest } from "../shared/GeoFenceAlertToggleRequest";
import * as moment from "moment";

@Component({
	selector: "caass-geo-fence-alert-table",
	templateUrl: "./geo-fence-alert-table.component.html",
	styleUrls: ["./geo-fence-alert-table.component.css"],
})
export class GeoFenceAlertTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private mapService: DataService_BusTrackerMap,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadGeoFenceAlertTxn();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() RefreshAlerts: EventEmitter<any> = new EventEmitter();

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGeoFenceAlertTxns: any;
	lstGeoFenceAlertTxn: any = [];

	//Filter lists
	lstGeoFenceDesc: any = [];
	lstGeofenceTriggerTypeDesc: any = [];
	lstSeverityDesc: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BusNbr", header: "Bus" },
		{ field: "GeoFenceDesc", header: "Geo Fence" },
		{ field: "GeofenceTriggerTypeDesc", header: "Trigger Type" },
		{ field: "SeverityDesc", header: "Severity" },
		{ field: "AlertComments", header: "Comments" },
		{ field: "StartDTDesc", header: "Start" },
		{ field: "EndDTDesc", header: "End" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGeoFenceAlertTxn() {
		this.errorMessage = "";

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.mapService.GeoFenceAlertSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstGeoFenceAlertTxn = response;

				//Load Data Filter Lists
				this.lstGeoFenceDesc = Array.from(new Set(this.lstGeoFenceAlertTxn.map((item: any) => item.GeoFenceDesc))).sort();
				this.lstGeofenceTriggerTypeDesc = Array.from(new Set(this.lstGeoFenceAlertTxn.map((item: any) => item.GeofenceTriggerTypeDesc))).sort();
				this.lstSeverityDesc = Array.from(new Set(this.lstGeoFenceAlertTxn.map((item: any) => item.SeverityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstGeoFenceAlertTxn.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGeoFenceAlertTxn();
	}

	//Custom Button Methods

	onActivate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.SelectedGeoFenceAlertTxns.length == 0) {
			this.errorMessage = "Select Alerts to Activate";
			return;
		}

		//
		// Create Parms
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedGeoFenceAlertTxns.length; z++) {
			var next = this.SelectedGeoFenceAlertTxns[z];

			lstIDs = [...lstIDs, next.GeoFenceAlertTxnID];
		}

		let parms: GeoFenceAlertToggleRequest = {
			lstGeoFenceAlertTxnIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.ActivateGeoFenceAlerts(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedGeoFenceAlertTxns = [];
					this.loadGeoFenceAlertTxn();
					this.RefreshAlerts.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "geofencealerts",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not activate the alerts",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDeactivate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.SelectedGeoFenceAlertTxns.length == 0) {
			this.errorMessage = "Select Alerts to Deactivate";
			return;
		}

		//
		// Create Parms
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedGeoFenceAlertTxns.length; z++) {
			var next = this.SelectedGeoFenceAlertTxns[z];

			lstIDs = [...lstIDs, next.GeoFenceAlertTxnID];
		}

		let parms: GeoFenceAlertToggleRequest = {
			lstGeoFenceAlertTxnIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.DeactivateGeoFenceAlerts(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedGeoFenceAlertTxns = [];
					this.loadGeoFenceAlertTxn();
					this.RefreshAlerts.emit(true);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "geofencealerts",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not deactivate the alerts",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadGeoFenceAlertTxn();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadGeoFenceAlertTxn();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = null;
	}
	onRowDblClick(BusAlertTxn) {
		this.errorMessage = "";
		// this.SelectedBusAlertTxn = BusAlertTxn;
		// this.onEditBusAlertTxn();
	}
	////////////////////////////////////////////
}
